import {
  audit,
  checkAudit,
  queryGapVolume2,
  queryWaybillNoCollectByRoute,
  selectAdjustRemarkBaseList,
  selectCollectDetail,
  selectCollectDetailList,
} from '@/services/AdjustmentApproval';

import { message } from 'antd';
import moment from 'moment';

export default {
  namespace: 'adjustmentApproval',
  state: {
    //单条数据
    queryInfo: null,
    drawerVisible: false,
    // 调整原因配置项
    adjustRemarkBaseList: [],
    // 临调货量情况
    collectDetail: [],
    // 临调货量明细
    collectDetailList: [],
    // 关联流向空爆数据
    waybillNoCollectList: [],
    // 申请分拨中心
    departureCenter: {
      site: {},
      // 申请分拨
      code: '', // 分拨编码
      name: '', // 分拨名称
    },
    // 组织信息
    organization: {},
  },
  effects: {
    /**
     * 获取调整原因配置项
     *
     * @param _ - 未使用的参数
     * @param {Object} actions - 包含了 call 和 put 的对象
     * @param {Function} actions.call - 调用其他 generator 函数或异步函数的函数
     * @param {Function} actions.put - 发送 action 到 redux store 的函数
     * @returns {void}
     */
    *selectAdjustRemarkBaseList(_, { call, put }) {
      const { code, data = [] } = yield call(selectAdjustRemarkBaseList, {});
      if (code === 1) {
        yield put({
          type: 'updateData',
          payload: {
            adjustRemarkBaseList: data.map((item) => ({
              ...item,
              label: item.value,
            })),
          },
        });
      }
    },
    *selectCollectDetailList({ payload, queryInfo }, { call, put }) {
      const data = yield call(selectCollectDetailList, payload);
      if (data?.code === 1) {
        yield put({
          type: 'updateData',
          payload: {
            collectDetailList: data.data || [],
            drawerVisible: true,
            queryInfo,
          },
        });
        yield put({
          type: 'selectCollectDetail',
          payload,
        });
        yield put({
          type: 'queryWaybillNoCollectByRoute',
          payload,
        });
      }
    },
    *selectCollectDetail({ payload }, { call, put }) {
      const data = yield call(selectCollectDetail, payload);
      if (data?.code === 1) {
        yield put({
          type: 'updateData',
          payload: {
            collectDetail: data.data || [],
          },
        });
      }
    },
    *queryWaybillNoCollectByRoute({ payload }, { call, put }) {
      const data = yield call(queryWaybillNoCollectByRoute, payload);
      if (data?.code === 1) {
        const waybillNoCollectList = data.data || [];
        const { startDate, endDate, carPlanDepartStartDate, carPlanDepartEndDate } =
          calculateTimeRange();
        if (waybillNoCollectList && waybillNoCollectList.length > 0) {
          const gapv2Params = {
            scanSiteCodes: [waybillNoCollectList[0]?.departureSiteCode], // 申请分拨
            nextSiteCodes: waybillNoCollectList.map((item) => item.adjustSiteCode), // 下一站
            queryType: 30,
            startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
            endDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
            carPlanDepartStartDate: carPlanDepartStartDate.format('YYYY-MM-DD HH:mm:ss'),
            carPlanDepartEndDate: carPlanDepartEndDate.format('YYYY-MM-DD HH:mm:ss'),
          };
          const gapVolumeData = yield call(queryGapVolume2, gapv2Params);
          if (gapVolumeData?.code === 1) {
            for (const item of waybillNoCollectList) {
              const gapVolume = gapVolumeData.data?.find(
                (itm) => itm.arrivalSiteCode === item.adjustSiteCode,
              );
              //当前空爆
              item.marginVolumeWeight = gapVolume?.gapVolumeBig2 || null;
              //调整后空爆=当前空爆+调整货量
              item.adjustVolumeWeight = gapVolume
                ? (
                    (parseFloat(gapVolume.gapVolumeBig2) * 1000 +
                      parseFloat(item.flowAdjustCalcWeightSum)) /
                    1000
                  ).toFixed(1)
                : null;
            }
          }
        }
        yield put({
          type: 'updateData',
          payload: {
            waybillNoCollectList,
          },
        });
      }
    },
    *audit({ payload, callback }, { call }) {
      const data = yield call(audit, payload);
      if (data?.code === 1) {
        data?.message && message.success(data.message);
        callback && callback();
      }
    },
    *checkAudit({ payload, callback }, { call }) {
      const data = yield call(checkAudit, payload);
      callback && callback(data);
    },
    *reset(_, { put }) {
      yield put({
        type: 'updateData',
        payload: {
          queryInfo: null,
          drawerVisible: false,
          waybillNoCollectList: [],
          collectDetail: [],
        },
      });
    },
  },
  reducers: {
    updateData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

/**
 * 计算时间范围
 * @returns {Object} 包含 startDate, endDate, carPlanDepartStartDate, carPlanDepartEndDate 的对象
 */
const calculateTimeRange = () => {
  const now = moment();
  let startDate, endDate;

  if (now.hour() < 12) {
    // 当前时间在12点之前
    startDate = moment().subtract(1, 'day').set({ hour: 12, minute: 0, second: 0 });
    endDate = moment().set({ hour: 12, minute: 0, second: 0 });
  } else {
    // 当前时间在12点之后
    startDate = moment().set({ hour: 12, minute: 0, second: 0 });
    endDate = moment().add(1, 'day').set({ hour: 12, minute: 0, second: 0 });
  }

  return {
    startDate,
    endDate,
    carPlanDepartStartDate: startDate,
    carPlanDepartEndDate: endDate,
  };
};
